export const isReadOnly = (user) => !!user && user.role === "read_only"

export const canWrite = (user) => !!user && !isReadOnly(user)
